import { MembersActions, MembersActionTypes } from "./members.actions";

export const membersFeatureKey = "members";

export class Member {
  uuid: string;
  email: string;
}

export class Role {
  uuid: string;
  name: string;
  description: string;
  tenant_uuid: string;
}

export interface MembersState {
  members: Member[];
  roles: Role[];
}

export const initialMembersState: MembersState = {
  members: [],
  roles: [],
};

export function membersReducer(
  state = initialMembersState,
  action: MembersActions,
) {
  const newState = Object.assign({}, state);
  switch (action.type) {
    case MembersActionTypes.SetMembers:
      newState.members = action.members;
      return newState;

    case MembersActionTypes.AddMember:
      newState.members = [...newState.members, action.member];
      return newState;

    case MembersActionTypes.RemoveMember:
      newState.members = newState.members.filter(
        (m) => m.uuid !== action.memberID,
      );
      return newState;

    case MembersActionTypes.SetRoles:
      newState.roles = action.roles;
      return newState;

    default:
      return state;
  }
}
